import { computed, defineComponent, onMounted, onUnmounted, onUpdated, ref } from 'vue';
import { Popover } from 'bootstrap';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { SupportAction, SupportGetter } from '@/store/support/support.module';
import { Support } from '@/store/support/support.model';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'SupportTableComponent',
  components: {
    LoadingComponent,
  },
  emits: [
    'edit'
  ],
  setup: (_, context) => {
    const dateFormat = useDateFormat();
    const store = useStore();
    const supports = computed<Support[]>(() => store.getters[SupportGetter.ALL]);
    const isLoading = computed(() => store.getters[SupportGetter.STATUS] === 'init' || store.getters[SupportGetter.STATUS] === 'loading');
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();
    const popoverList = ref<Popover[]>([]);

    onMounted(() => {
      store.dispatch(SupportAction.FETCH)
        .then(() => updateDataTable());
    });

    onUpdated(() => updateDataTable());

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    const updateDataTable = () => {
      Promise.resolve(initialPopover())
        .then(() => initialDataTable());
    };

    const initialDataTable = () => {
      Promise.resolve(dtInstance.value?.destroy())
        .then(() => {
          const dt = datatable.value as HTMLTableElement;
          if (!$.fn.dataTable.isDataTable(dt)) {
            dtInstance.value = $(dt).DataTable({
              language: {
                emptyTable: 'ไม่พบข้อมูล',
                info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
                infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
                infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
                lengthMenu: 'แสดงข้อมูล _MENU_',
                paginate: {
                  next: 'ถัดไป',
                  previous: 'ก่อนหน้า',
                  first: 'First',
                  last: 'Last'
                },
                search: 'ค้นหา:',
                zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
              }
            });
          }
        });
    };

    const initialPopover = () => {
      const popoverTriggerList = computed<HTMLElement[]>(() => [].slice.call(document.querySelectorAll('[data-bs-toggle="popover-item"]')) as HTMLElement[]);
      popoverList.value.map(element => element.hide());
      popoverList.value = popoverTriggerList.value?.map(element => new Popover(element, { trigger: 'hover', placement: 'right' }));
    };

    const selectedClick = (id: number) => {
      context.emit('edit', id);
    };

    const toggleClick = (id: number) => {
      const item = supports.value.find(m => m.id == id);
      store.dispatch(SupportAction.PINNING, {
        id: id,
        pined: !item?.pined,
      });
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'short');

    return {
      supports,
      datatable,
      isLoading,
      selectedClick,
      toggleClick,
      thaiDate,
    };
  },
});

